import { type ReactNode, createContext, useRef } from 'react';

import { createTokenStore, DEFAULT_STATE, TokenState } from './';

export type TokenStoreApi = ReturnType<typeof createTokenStore>;

export const TokenStoreContext = createContext<TokenStoreApi | undefined>(undefined);

export interface TokenStoreProviderProps {
  children: ReactNode;
  initialState?: TokenState;
}

export const TokenStoreProvider = ({
  children,
  initialState = DEFAULT_STATE,
}: TokenStoreProviderProps) => {
  const storeRef = useRef<TokenStoreApi | null>(null);
  if (storeRef.current === null) {
    storeRef.current = createTokenStore(initialState);
  }

  return (
    <TokenStoreContext.Provider value={storeRef.current}>{children}</TokenStoreContext.Provider>
  );
};
